import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

/**
 * Records a click for a short public URL (e.g. /mm) then sends the visitor to the home page.
 */
function PodcastCampaignRedirect() {
  const navigate = useNavigate();
  const { adSlug } = useParams();
  const slug = typeof adSlug === 'string' ? adSlug.toLowerCase() : '';

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (slug) {
          await api.post(`/ad-links/${encodeURIComponent(slug)}/click`);
        }
      } catch (e) {
        console.warn('Podcast link click could not be recorded:', e?.message || e);
      } finally {
        if (!cancelled) {
          navigate('/', { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug, navigate]);

  return (
    <div className="page-loading" aria-live="polite">
      <div className="loading-spinner" />
    </div>
  );
}

export default PodcastCampaignRedirect;
